import { Lock } from "lucide-react";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { PanelInlineContent } from "../../lib/panel/panel-inline-content";
import { useTranslation } from "react-i18next";

// The trigger type is chosen at creation and cannot be changed afterwards
// (switching it would invalidate downstream conditions/variables). Its
// configuration parameters remain editable in the dedicated sub-panels.
export function PanelTriggerType() {
  const form = useWorkflowForm();
  const { t } = useTranslation("trackoffice");
  // Cast to string to handle extended trigger types not yet in API client
  const triggerType = form.watch("workflow.trigger.data.triggerType") as string;

  return (
    <PanelInlineContent title="Type">
      <div
        className="flex items-center gap-1.5 text-xs"
        title={t(
          "workflowsEditor.triggerNode.lockedHint",
          "Trigger type can't be changed.",
        )}
      >
        <span className="font-medium">
          {t(`workflowsEditor.triggerTypes.${triggerType}.title`)}
        </span>
        <Lock className="size-3 text-muted-foreground" />
      </div>
    </PanelInlineContent>
  );
}
